module.exports = __webpack_public_path__ + "img/result_desk_angle.c1cc8981.jpg";